import React from "react";
import { connect } from "react-redux";

import Authorized from "./ui/screens/authorized/router";
import Unauthorized from "./ui/screens/unauthorized/router";
import SplashScreen from "./ui/screens/app.loading";

function useDelayUnmount(isMounted: boolean, delayTime: number) {
  const [shouldRender, setShouldRender] = React.useState(false);

  React.useEffect(() => {
    let timeoutId: number;
    if (isMounted && !shouldRender) {
      setShouldRender(true);
    } else if (!isMounted && shouldRender) {
      timeoutId = setTimeout(() => setShouldRender(false), delayTime);
    }
    return () => clearTimeout(timeoutId);
  }, [isMounted, delayTime, shouldRender]);
  return shouldRender;
}

const App = ({ appReady, isAuthenticated }) => {
  const shouldRenderChild = useDelayUnmount(!appReady, 500);
  const mountedStyle = {
    opacity: 1,
    transition: "opacity 10ms ease-in",
    top: 0,
  };
  const unmountedStyle = { opacity: 0, transition: "opacity 10ms ease-out" };

  return (
    <>
      {shouldRenderChild && (
        <SplashScreen style={!appReady ? mountedStyle : unmountedStyle} />
      )}

      {appReady && isAuthenticated ? <Authorized /> : <Unauthorized />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    appReady: state.App.isReady,
    isAuthenticated: state.Auth.isAuthenticated,
  };
};

export default connect(mapStateToProps)(App);
